import React from 'react';
import {Link} from 'react-router';
import { Dialog } from "@blueprintjs/core";
import {Input, TextArea} from 'components/tt-forms/common';
import { API_URL } from 'constants/config';

class InPhieuGiaoTTXMToCao extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpen: false,
      tenCoQuan: '',
      ghiChu: '',
      noiDungDonThu: ''
    }
  }

  inPhieuGiaoTTXMToCao() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let URL = String(API_URL) + "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhToCao?"
    + "tenCoQuan=" + this.state.tenCoQuan
    + "&donViXuLyId=" + userInfo.donViId
    + "&ghiChu=" + this.state.ghiChu;
    window.open(URL, "_self");
    this.toggleDialog();
  }

  toggleDialog() {
    this.setState({
      isOpen: !this.state.isOpen,
      tenCoQuan: '',
      ghiChu: '',
      noiDungDonThu: ''
    });
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  render() {
    return (
      <div className="col-50 pb15">
        <Link className="btn-green tt-print" onClick={this.toggleDialog.bind(this)}>Tải quyết định giao nhiệm vụ xác minh nội dung tố cáo</Link>
        <Dialog
          isOpen={this.state.isOpen}
          onClose={this.toggleDialog.bind(this)}
          title="Thông tin quyết định giao nhiệm vụ xác minh nội dung tố cáo"
          className="dialog-history dialog-print wrap-block"
          >
          <div className="body-dialog-gh">
            <div className="row pl30 pr30 pt15">
              <Input className="col-25" label="Tên cơ quan" value={this.state.tenCoQuan} onChange={this.onChange.bind(this, 'tenCoQuan')}/>
              <TextArea label="Tóm tắt nội dung đơn thư" value={this.state.noiDungDonThu} onChange={this.onChange.bind(this, 'noiDungDonThu')}/>
              <TextArea label="Ghi chú" value={this.state.ghiChu} onChange={this.onChange.bind(this, 'ghiChu')} maxLength={1000} />
            </div>
          </div>
          <div className="box-bottom gqd-wrap col-100">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.toggleDialog.bind(this)}><span>Đóng</span></Link>
            <Link className="btn-green tt-print" onClick={this.inPhieuGiaoTTXMToCao.bind(this)}><span>Tải quyết định</span></Link>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default InPhieuGiaoTTXMToCao;



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/InPhieuGiaoTTXMToCao.jsx